var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",on:{"click":function($event){return _vm.cancelBet()}}},[_vm._v(" "+_vm._s(_vm.t('Betslip.CancelBet'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }